import React, { useState } from 'react';
import { ChevronDownIcon, KeyIcon, UserCircle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
type MenuItem = {
  label: string;
  submenu?: {
    label: string;
    path: string;
  }[];
};
const menuItems: MenuItem[] = [{
  label: 'Dashboard',
  submenu: [{
    label: 'Scouting',
    path: '/dashboard/scouting'
  }, {
    label: 'Platform',
    path: '/dashboard/platform'
  }]
}, {
  label: 'Players',
  submenu: [{
    label: 'All',
    path: '/players/all'
  }, {
    label: 'My Favourite',
    path: '/players/favorites'
  }, {
    label: 'My Searches',
    path: '/players/searches'
  }]
}, {
  label: 'Teams',
  submenu: [{
    label: 'All',
    path: '/teams/all'
  }, {
    label: 'My Team',
    path: '/teams/my-team'
  }, {
    label: 'My Favourite',
    path: '/teams/favorites'
  }]
}, {
  label: 'Matches',
  submenu: [{
    label: 'Table',
    path: '/matches/table'
  }, {
    label: 'Calendar',
    path: '/matches/calendar'
  }]
}, {
  label: 'Reports',
  submenu: [{
    label: 'TBD',
    path: '/reports'
  }]
}];
const Navigation = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const location = useLocation();
  const isActiveRoute = (item: MenuItem) => {
    return item.submenu?.some(subItem => location.pathname.startsWith(subItem.path));
  };
  return <div className="bg-white shadow-md" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-10">
        <div className="flex items-center space-x-2 w-48" data-id="element-11">
          <span className="font-bold text-lg" data-id="element-12">LOGO</span>
        </div>
        <div className="flex justify-center" data-id="element-13">
          {menuItems.map(item => <div key={item.label} className="relative" onMouseEnter={() => setHoveredItem(item.label)} onMouseLeave={() => setHoveredItem(null)} data-id="element-14">
              <button className={`px-4 py-3 flex items-center space-x-1 text-sm font-medium transition-colors
                  ${isActiveRoute(item) ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-700 hover:text-blue-600'}`} data-id="element-15">
                <span data-id="element-16">{item.label}</span>
                {item.submenu && item.submenu.length > 0 && <ChevronDownIcon className="w-4 h-4" data-id="element-17" />}
              </button>
            </div>)}
        </div>
        <div className="flex items-center space-x-3 w-48 justify-end" data-id="element-18">
          <span className="text-sm font-medium text-gray-700" data-id="element-19">Nome Utente</span>
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-20">
            <UserCircle className="w-6 h-6 text-gray-600" data-id="element-21" />
          </div>
        </div>
      </div>
      {/* Secondary Navigation */}
      <div className="bg-gray-200" data-id="element-22">
        <div className="max-w-7xl mx-auto px-4" data-id="element-23">
          <div className="flex space-x-6 py-2" data-id="element-24">
            <Link to="/players/all" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-25">
              All
            </Link>
            <Link to="/players/favorites" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-26">
              My Favourite
            </Link>
            <Link to="/players/searches" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-27">
              My Searches
            </Link>
            <Link to="/players/suggestion" className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-28">
              Suggestion
            </Link>
          </div>
        </div>
      </div>
      {hoveredItem && menuItems.find(item => item.label === hoveredItem)?.submenu && <div className="absolute w-full bg-white border-t border-gray-100 shadow-sm" onMouseEnter={() => setHoveredItem(hoveredItem)} onMouseLeave={() => setHoveredItem(null)} data-id="element-29">
            <div className="max-w-7xl mx-auto px-4 py-2" data-id="element-30">
              <div className="flex space-x-6" data-id="element-31">
                {menuItems.find(item => item.label === hoveredItem)?.submenu?.map(subItem => <Link key={subItem.path} to={subItem.path} className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-32">
                      {subItem.label}
                    </Link>)}
              </div>
            </div>
          </div>}
    </div>;
};
export default Navigation;